import { render, staticRenderFns } from "./prizesLogList.vue?vue&type=template&id=40d79386&scoped=true"
import script from "./prizesLogList.vue?vue&type=script&lang=js"
export * from "./prizesLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d79386",
  null
  
)

export default component.exports